import { useInView } from "@/hooks/customHooks";
import { useLazyMallAction } from "@/store/lazyMallStore";
import { useEffect, useRef } from "react";

function ObservedLine() {
    const observedTarget = useRef<HTMLDivElement>(null);
    const { setIsObseredTop } = useLazyMallAction()
    const [observeTop] = useInView((isObservedTop: boolean) => {
        setIsObseredTop(isObservedTop);
    });
    /*👆variable */

    /*👇method */
    useEffect(() => {
        setIsObseredTop(true)
        observeTop(observedTarget.current);
        return () => {
            setIsObseredTop(true)
        }
    }, [])
    
    return (
        <div ref={observedTarget}></div>
    );
}

export default ObservedLine;